export default {
  Afghanistan: '/images/flags/Afghanistan.webp',
  Australia: '/images/flags/Australia.webp',
  Bangladesh: '/images/flags/Bangladesh.webp',
  England: '/images/flags/England.webp',
  India: '/images/flags/India.webp',
  Ireland: '/images/flags/Ireland.webp',
  New: '/images/flags/New-Zealand.webp',
  Pakistan: '/images/flags/Pakistan.webp',
  South: '/images/flags/South Africa.webp',
  Srilanka: '/images/flags/Sri-Lanka.webp',
  West: '/images/flags/West-Indies.webp',
  Zimbabwe: '/images/flags/Zimbabwe.webp'
} as any;
